import React from 'react';
import HelpLink from '../../components/HelpLink';

const Dmca = ({}) => (
    <div>
        <h2 className="text-center"><u>TERMS OF SERVICE</u></h2>
        <h2>1. Your Use of Content</h2>
        <p>
            In
            addition to any other restrictions described on this website, the
            following restrictions and conditions apply specifically to your use
            of the content on this website.
        </p>
        <ol type="A">
            <li>
                <p>
                    The content on this website (Content), and the trademarks, service
                    marks and logos ("Marks") on the Service, are owned by or
                    licensed to StorageTreasures.com (StorageTreasures), subject to
                    copyright and other intellectual property rights under the law.
                </p>
            </li>
            <li>
                <p>
                    Content is provided to you AS IS. You may access Content for your
                    information and personal use solely as intended through the provided
                    functionality of the services provided on this website (Services)
                    and as permitted under the website Terms of Service. You shall not
                    download any Content unless you see a “download” or similar link
                    displayed by StorageTreasures on the Service for that
                    Content. You shall not copy, reproduce, distribute, transmit,
                    broadcast, display, sell, license, or otherwise exploit any Content
                    for any other purposes without the prior written consent of
                    StorageTreasures or the respective licensors of the Content,
                    StorageTreasures and its licensors reserve all rights not
                    expressly granted in and to the Service and the Content.
                </p>
            </li>
            <li>
                <p>
                    You agree not to circumvent, disable or otherwise interfere with
                    security-related features of the Service or features that prevent or
                    restrict use or copying of any Content or enforce limitations on use
                    of the Service or the Content therein.
                </p>
            </li>
            <li>
                <p>
                    You understand that when using the Service, you may/will be exposed
                    to Content from a variety of sources, and that StorageTreasures
                    is not responsible for the accuracy, usefulness, safety, or
                    intellectual property rights of or relating to such Content. You
                    further understand and acknowledge that you may be exposed to
                    Content that is inaccurate, offensive, indecent, or objectionable,
                    and you agree to waive, and hereby do waive, any legal or equitable
                    rights or remedies you have or may have against StorageTreasures
                    with respect thereto, and, to the extent permitted by applicable
                    law, agree to indemnify and hold harmless StorageTreasures, its
                    owners, operators, affiliates, licensors, and licensees to the
                    fullest extent allowed by law regarding all matters related to your
                    use of the Service.
                </p>
            </li>
        </ol>
        <h2>2. Your Content and Conduct</h2>
        <ol type="A">
            <li>
                <p>
                    As a StorageTreasures User you may
                    submit Content to the Service. You understand that StorageTreasures
                    does not guarantee any confidentiality with respect to any Content
                    you submit.
                </p>
            </li>
            <li>
                <p>
                    You shall be solely responsible for your own Content and the
                    consequences of submitting and publishing your Content on the
                    Service. You affirm, represent, and warrant that you own or have the
                    necessary licenses, rights, consents, and permissions to publish
                    Content you submit; and you license to StorageTreasures all patent,
                    trademark, trade secret, copyright or other proprietary rights in
                    and to such Content for publication on the Service pursuant to the
                    website Terms of Service.
                </p>
            </li>
            <li>
                <p>
                    For clarity, you retain all of your ownership rights in your
                    Content. However, by submitting Content to StorageTreasures, you
                    hereby grant StorageTreasures a worldwide, non-exclusive,
                    royalty-free, sublicensable and transferable license to use,
                    reproduce, distribute, prepare derivative works of, display, and
                    perform the Content in connection with the Service and
                    StorageTreasures (and its successors' and affiliates') business,
                    including without limitation for promoting and redistributing part
                    or all of the Service (and derivative works thereof) in any media
                    formats and through any media channels. You also hereby grant each
                    user of the Service a non-exclusive license to access your Content
                    through the Service, and to use, reproduce, distribute, display and
                    perform such Content as permitted through the functionality of the
                    Service and under these Terms of Service.
                </p>
            </li>
            <li>
                <p>
                    You further agree that Content you submit to the Service will not
                    contain third party copyrighted material, or material that is
                    subject to other third party proprietary rights, unless you have
                    permission from the rightful owner of the material or you are
                    otherwise legally entitled to post the material and to grant
                    StorageTreasures all of the license rights granted herein.
                </p>
            </li>
            <li>
                <p>
                    You further agree that you will not submit to the Service any
                    Content or other material that is contrary to the StorageTreasures
                    User Obligations contained in the Terms of Use,
                    currently found at
                    {' '}
                    <a target="_blank" href="https://www.storagetreasures.com/terms">https://www.storagetreasures.com/terms</a>
                    , which may be updated from time to time, or contrary to
                    applicable local, national, and international laws and regulations.
                </p>
            </li>
            <li>
                <p>
                    StorageTreasures does not endorse any Content submitted to the
                    Service by any user or other licensor, or any opinion,
                    recommendation, or advice expressed therein, and StorageTreasures
                    expressly disclaims any and all liability in connection with
                    Content. StorageTreasures does not permit copyright infringing
                    activities and infringement of intellectual property rights on the
                    Service, and StorageTreasures will remove all Content if
                    properly notified that such Content infringes on another's
                    intellectual property rights. StorageTreasures reserves the right to
                    remove Content without prior notice.
                </p>
            </li>
        </ol>
        <h2>3. Account Termination Policy</h2>
        <ol type="A">
            <li>
                <p>
                    StorageTreasures will terminate a user's access to the
                    Service if, under appropriate circumstances, the user is determined
                    to be a repeat infringer.
                </p>
            </li>
            <li>
                <p>
                    StorageTreasures reserves the right to decide whether Content
                    violates these Terms of Service for reasons other than copyright
                    infringement, such as, but not limited to, pornography, obscenity,
                    or excessive length. StorageTreasures may
                    at any time, without prior notice and in its sole discretion, remove
                    such Content and/or terminate a user's account for submitting such
                    material in violation of the website Terms of Service.
                </p>
            </li>
        </ol>
        <h2>4. Digital Millennium Copyright Act</h2>
        <ol type="A">
            <li>
                <p>
                    If you are a copyright owner or an agent thereof and believe that
                    any Content infringes upon your copyrights, you may submit a
                    notification pursuant to the Digital Millennium Copyright Act
                    ("DMCA") by providing our Copyright Agent with the
                    following information in writing (see 17 U.S.C 512(c)(3) for further
                    detail):
                </p>
                <ul>
                    <li>
                        <p>
                            A physical or electronic signature of a person authorized to act on
                            behalf of the owner of an exclusive right that is allegedly
                            infringed;
                        </p>
                    </li>
                    <li>
                        <p>
                            Identification of the copyrighted work claimed to have been
                            infringed, or, if multiple copyrighted works at a single online
                            site are covered by a single notification, a representative list of
                            such works at that site;
                        </p>
                    </li>
                    <li>
                        <p>
                            Identification of the material that is claimed to be infringing or
                            to be the subject of infringing activity and that is to be removed
                            or access to which is to be disabled and information reasonably
                            sufficient to permit the service provider to locate the material;
                        </p>
                    </li>
                    <li>
                        <p>
                            Information reasonably sufficient to permit the service provider to
                            contact you, such as an address, telephone number, and, if
                            available, an electronic mail;
                        </p>
                    </li>
                    <li>
                        <p>
                            A statement that you have a good faith belief that use of the
                            material in the manner complained of is not authorized by the
                            copyright owner, its agent, or the law; and
                        </p>
                    </li>
                    <li>
                        <p>
                            A statement that the information in the notification is accurate,
                            and under penalty of perjury, that you are authorized to act on
                            behalf of the owner of an exclusive right that is allegedly
                            infringed.
                        </p>
                    </li>
                </ul>
            </li>
        </ol>
        <p>
            You may direct copyright infringement notifications to our DMCA Agent
            at 2101 W Peoria Ave Unit 100, Phoenix, AZ 85029,
            email:
            {' '}
            <a target="_blank" className="text-danger" href="mailto:DMCAagent@opentechalliance.com">DMCAagent@opentechalliance.com</a>
            ,
            fax: 602.324.8658. For clarity, only DMCA notices should go to the
            DMCA Agent; any other feedback, comments, requests for technical
            support, and other communications should be directed to customer
            service through
            {' '}
            <HelpLink url="/requests/new">Submit a request</HelpLink>
            .
            You acknowledge that if you fail to comply with all of the
            requirements of this Section 5(D), your DMCA notice may not be valid.
        </p>
        <ol type="A" start="2">
            <li>
                <p>
                    Counter-Notice. If you believe that your Content that was removed
                    (or to which access was disabled) is not infringing, or that you
                    have the authorization from the copyright owner, the copyright
                    owner's agent, or pursuant to the law, to post and use the material
                    in your Content, you may send a counter-notice containing the
                    following information to the DMCA
                    Agent:
                </p>
                <ul>
                    <li>
                        <p>
                            Your physical or electronic signature;
                        </p>
                    </li>
                    <li>
                        <p>
                            Identification of the Content that has been removed or to which
                            access has been disabled and the location at which the Content
                            appeared before it was removed or disabled;
                        </p>
                    </li>
                    <li>
                        <p>
                            A statement that you have a good faith belief that the Content was
                            removed or disabled as a result of mistake or a misidentification
                            of the Content; and
                        </p>
                    </li>
                    <li>
                        <p>
                            Your name, address, telephone number, and e-mail address, a
                            statement that you consent to the jurisdiction of the federal court
                            in Phoenix, Arizona, and a statement that you will accept service
                            of process from the person who provided notification of the alleged
                            infringement.
                        </p>
                    </li>
                </ul>
            </li>
        </ol>
        <p>
            If a
            counter-notice is received by the DMCA Agent, service provider may
            send a copy of the counter-notice to the original complaining party
            informing that person that it may replace the removed Content or
            cease disabling it in 10 business days. Unless the copyright owner
            files an action seeking a court order against the Content provider,
            member or user, the removed Content may be replaced, or access to it
            restored, in 10 to 14 business days or more after receipt of the
            counter-notice, at service provider’s sole discretion.
        </p>
    </div>
);

Dmca.getInitialProps = () => {
    const pageData = { title: 'DMCA Notice', marginBottom: 'pageTitle marginB20', h1: 'DMCA Notice', description: undefined };

    return { pageData };
};

export default Dmca;